// @ts-nocheck
// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Spin, Button, Col, Row } from 'antd';
import { Document, Page, pdfjs } from 'react-pdf';
import {
	getPrintPreviewV2,
	createPrintPdf,
	saveLabResult,
	retrieveReport,
	generateNewReport,
	printToPrinter
} from 'services/lab_result/result';
import { CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons';
import Message from 'shared_components/message';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class PrintResult extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			imageSrc: null,
			pageNumber: 1,
			isReadyToPrint: false,
			numPages: null,
			baseSixtyFour: null,
		};

		this.timer = null;
	}

	// componentDidMount() {
	// 	this.setState({ isReadyToPrint: true, baseSixtyFour: null});
	// 	// window.addEventListener('message', e => {
	// 	// 	// console.log('event Listener =>',e.data)
	// 	// 	if (e.data.isReadyToPrint) {
	// 	// 		this.setState({ isReadyToPrint: true });
	// 	// 	}
	// 	// });
	// }

	onDocumentLoadSuccess = ({ numPages }) => {
		this.setState({
			numPages,
			isReadyToPrint: true,
		});
	};

	
	componentDidUpdate(prevProps) {
		const { requestID, sampleID, resultStatus, sectionName, specimenStatusID, visible } = this.props;
		const { isReadyToPrint } = this.state;

		if ((prevProps.sampleID !== sampleID || prevProps.requestID !== requestID) && isReadyToPrint) {
			this.setState({ isReadyToPrint: false, imageSrc: null});
		}

		const appName = 'labhero';
			const moduleName = sectionName;
			const reportName = 'lab.jrxml';
			const parameters = JSON.stringify([{ reqid: requestID, ssid: sampleID }]);


		if (!prevProps.visible && visible && sampleID !== null) {

			if (resultStatus === 'Approved' || specimenStatusID === 3) {
				console.log('to function validate');
				this.validateReport(appName, moduleName, reportName, parameters, requestID, sampleID);
			} else {
				console.log('will generate report if not approved');
				this.generateNewReport(appName, moduleName, parameters, requestID, sampleID);
			}
		}
	}

	validateReport = async (appName, moduleName, reportName, parameters, requestID, sampleID) => {
		const printPreview = await retrieveReport(appName, moduleName, reportName, requestID, sampleID);

		if (printPreview === false) {
			console.log('no record');
			this.generateNewReport(appName, moduleName, parameters, requestID, sampleID);
		} else {
			console.log('with record');
			const baseSixtyFour = printPreview.records[0].pdf;
			this.setState({ isReadyToPrint: true, imageSrc: baseSixtyFour }, this.startPrintTimer);
		}
	};

	generateNewReport = async (appName, moduleName) => {

		const { requestID, sampleID} = this.props;

		const parameters = {
			mode: 'export',
			parameters: [
				{
					reqid: requestID,
					ssid: sampleID,
				},
			],
		};

		const printPreview = await generateNewReport(appName, moduleName, parameters);
		try {
			const newBaseSixtyFour = printPreview.records[0].pdf;
			this.setState({ isReadyToPrint: true, imageSrc: newBaseSixtyFour }, this.startPrintTimer);
		} catch (err) {
			console.log(err);
		}
	};

	startPrintTimer = () => {
		this.timer = setInterval(() => {
			const { isReadyToPrint } = this.state;
			if (isReadyToPrint) {
				clearInterval(this.timer);
				this.timer = null;
			}
		}, 100);
	};
	
	setImageState = baseSixtyFour => {
		// eslint-disable-next-line react/no-did-update-set-state
		this.setState({ imageSrc: baseSixtyFour }, () => {
			this.timer = setInterval(() => {
				const { isReadyToPrint } = this.state;

				if (isReadyToPrint) {
					// this.printResult(); will use for new print button ACD 02032023

					clearInterval(this.timer);

					this.timer = null;
				}
			}, 100);
		});
	};

	onClickApprove = async () => {
		const { getLabResultFormValues, onSaveSuccess, resultStatus, onPrint, specimenStatusID } = this.props;
		const labResultFormValues = await getLabResultFormValues();
		console.log(labResultFormValues);
		const userSession = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
		const action = specimenStatusID === 3 ? 'Unapproved' : 'Approved';

		if (!labResultFormValues.form.hasError && !labResultFormValues.remarks.hasError) {
			this.setState({ isApproving: true }, async () => {
				const savedResults = await saveLabResult({
					results: labResultFormValues.form.results,
					remarks: labResultFormValues.remarks.value ? labResultFormValues.remarks.value : '',
					userID: userSession.userID,
					action,
				});

				this.setState({ isApproving: false }, () => {
					if (savedResults) {
						onSaveSuccess();
						// Message.success({ message: `Result have successfully ${action.toLowerCase()}.` });
						Message.success({
							message: `Result successfully approved.`
						});

						// if (action === 'Approve') {
						// 	onPrint(); //will print if approved
						// }
					}
				});

				// this.printResult();
			});
		}
	};

	onClickPrintPdf = async () => {
		console.log('test print canil');

		const { requestID, sampleID } = this.props;

		const printPreview = await getPrintPreviewV2(requestID, sampleID);

		const payload = {
			requestID: requestID,
			sampleSpecimenID: sampleID,
			baseSixtyFour: printPreview.pdf,
		};
		console.log(payload);

		const response = await createPrintPdf(payload);

		if (response !== 500) {
			Message.success({ message: `Print Success.` });
		} else {
			Message.error({ message: `Failed to Print.` });
		}
	};

	onClickPrintToPrinter = async () =>{

		const { requestID, sampleID, sectionName } = this.props;
		const appName = 'labhero';
		const moduleName = sectionName;
		const reportName = 'hematology_default.jrxml';
		// const parameters = JSON.stringify([{ reqid: requestID, ssid: sampleID }]);

		const parameters = {
			parameters: [
				{
					reqid: requestID,
					ssid: sampleID
				},
			],
			daxparameters: [
				{
					mrequestid: requestID,
					msampleid: sampleID,
					muserid: "1"
				},
			],
		};
		const printToPrinterFunction = await printToPrinter(appName, moduleName, reportName, parameters);
		Message.info(printToPrinterFunction.message); 
	}

	printResult = async () => {
		const id = 'result';
		const iframe = document.frames ? document.frames[id] : document.getElementById(id);

		const iframeWindow = iframe.contentWindow || iframe;

		iframe.focus();
		iframeWindow.print();
	};

	onCloseDrawer = () => {
		const { onClose } = this.props;

		if (this.timer) {
			clearInterval(this.timer);
		}

		onClose();
	};

	onNav = action => {
		const { pageNumber } = this.state;
		this.setState({
			pageNumber: action === 'NEXT' ? pageNumber + 1 : pageNumber - 1,
		});
	};

	render() {
		const { pageNumber, imageSrc, isReadyToPrint, numPages, isLoading } = this.state;
		const { visible, sampleID, requestID, onClose, resultStatus, specimenStatus, specimenStatusID } = this.props;

		return (
			<Drawer
				title="LABORATORY RESULT PRINT PREVIEW"
				width="700"
				placement="right"
				closable
				onClose={this.onCloseDrawer}
				visible={visible}
			>
				<section>
					{sampleID && sampleID !== null && visible && (
						<Spin spinning={!isReadyToPrint && visible}>
							<iframe
								id="result"
								// src={imageSrc}
								// src={`${process.env.PUBLIC_URL}/reports/jrprintform/labhero/hematology/$lab.jrxml`}
								style={{ height: 0, width: 0, position: 'absolute' }}
								title="result"
							/>
							<Document
								file={`data:application/pdf;base64,${imageSrc}`}
								onLoadSuccess={this.onDocumentLoadSuccess}
								onLoadError={console.error}
								renderMode="svg"
							>
								<Page pageNumber={pageNumber} renderMode="svg" />
								<Row>
									<Col span={8}>
										{numPages === 1 ? null : (
											<>
												<Button
													type="text"
													icon={<CaretLeftOutlined />}
													onClick={() => this.onNav('BACK')}
												/>
												<Button
													type="text"
													icon={<CaretRightOutlined />}
													onClick={() => this.onNav('NEXT')}
												/>
											</>
										)}
									</Col>
									<Col span={8} offset={8}>
										<p>
											Page {pageNumber} of {numPages}
										</p>
									</Col>
								</Row>
							</Document>
							<div></div>
						</Spin>
					)}
				</section>
				{resultStatus === 'Approved' || specimenStatus === 'Approved' || specimenStatusID === 3 ? 
					<section className="drawerFooter">
					<div>
						<Button
							shape="round"
							type="primary"
							loading={!isReadyToPrint && visible}
							style={{ margin: 10, width: 120 }}
							onClick={this.onClickPrintToPrinter}
						>
							PRINT
						</Button>
					</div>
				</section>
				: (
					<section className="drawerFooter">
						<div>
							<Button shape="round" style={{ margin: 10, width: 120 }} onClick={onClose}>
								CANCEL
							</Button>
							<Button
								shape="round"
								type="primary"
								loading={!isReadyToPrint && visible}
								style={{ margin: 10, width: 120 }}
								onClick={this.onClickApprove}
							>
								APPROVE
							</Button>
						</div>
					</section>
				)}
			</Drawer>
		);
	}
}

PrintResult.propTypes = {
	requestID: PropTypes.string,
	sampleID: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
	resultStatus: PropTypes.string,
	specimenStatus: PropTypes.string.isRequired,
};

PrintResult.defaultProps = {
	requestID: null,
	sampleID: null,
	resultStatus: null,
	specimenStatus: null,
};

export default PrintResult;
